module.exports = __webpack_public_path__ + "img/list-icon.b2c62627.svg";